module.exports = __webpack_public_path__ + "img/router-1.e516370c.webp";